import { FC } from 'react';

import useTicketClosePopup from './hooks/useTicketClosePopup';
import {
  ActionBtnStyled,
  ControlsWrapStyled,
  FlexContainerMessageStyled,
  getPopupContentStyle,
} from './TicketClosePopup.styled';
import ErrorSection from 'components/ErrorSection/ErrorSection';
import Popup from 'components/Popup/Popup';
import SuccessSection from 'components/SuccessSection/SuccessSection';
import Typography from 'components/Typography/Typography';
import { useResponsive } from 'contexts/ResponsiveContext';
import { ScrollLockIdE } from 'declarations/enums/scroll';
import { NoopT } from 'declarations/types/common';

type TicketApprovePopupPropsT = {
  ticketId: string;
  isOpen: boolean;
  onClose: NoopT;
};

const TicketApprovePopup: FC<TicketApprovePopupPropsT> = ({ ticketId, isOpen, onClose }) => {
  const { isMobile } = useResponsive();
  const {
    isClosingTicket,
    isTicketSuccessfullyClosed,
    isTicketClosingError,
    showPopupContent,
    handleCloseTicket,
    handleClosePopup,
    closeTicketErrorMessage,
    closeTicketValidationErrorMessage,
  } = useTicketClosePopup();

  return (
    <Popup
      nested
      isOpen={isOpen}
      showCloseBtn={isTicketSuccessfullyClosed || isTicketClosingError}
      popupId={ScrollLockIdE.TicketClosePopup}
      contentStyle={getPopupContentStyle(isMobile)}
      onClose={handleClosePopup(onClose)}
      closeOnEscape={false}
    >
      {showPopupContent && (
        <>
          <Typography color="darkBlue" variant="h2" align={isMobile ? 'center' : 'left'}>
            Are you sure you want to close the ticket?
          </Typography>
          <ControlsWrapStyled justify={isMobile ? 'center' : 'flex-end'}>
            <ActionBtnStyled
              type="button"
              variant="outline"
              size="xl"
              onClick={handleClosePopup(onClose)}
            >
              Cancel
            </ActionBtnStyled>
            <ActionBtnStyled
              variant="contained"
              size="xl"
              isLoading={isClosingTicket}
              onClick={handleCloseTicket([ticketId])}
            >
              Close
            </ActionBtnStyled>
          </ControlsWrapStyled>
        </>
      )}

      {isTicketSuccessfullyClosed && (
        <FlexContainerMessageStyled direction="column">
          <SuccessSection message="Ticket successfully closed" />
        </FlexContainerMessageStyled>
      )}

      {isTicketClosingError && (
        <FlexContainerMessageStyled direction="column">
          <ErrorSection
            errorDetails={closeTicketErrorMessage || closeTicketValidationErrorMessage}
          />
        </FlexContainerMessageStyled>
      )}
    </Popup>
  );
};

export default TicketApprovePopup;
